import React from 'react';
import './Home.css';
import Newsletter from '../components/Newsletter';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section
        className="hero"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/hero-bg.jpg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="hero-content">
          <h1 className="hero-title">European brief therapy association</h1>
          <p className="hero-subtitle">
            An open, non-profit, civil society organization for people interested in supporting solution-focused work in different contexts
          </p>
          <div className="hero-buttons">
            <a href="/membership" className="btn btn-outline">BECOME A MEMBER</a>
            <a href="https://buchshop.bod.de/catalogsearch/result/?q=ebta" target="_blank" rel="noopener noreferrer" className="btn btn-outline">GET A COPY OF OUR (E-)BOOK!</a>
            <a href="/sf-research" className="btn btn-outline">SF PUBLIST</a>
          </div>
        </div>
        <div className="hero-overlay"></div>
      </section>

      {/* Mission & Vision Section */}
      <section className="mission-vision">
        <div className="container">
          <div className="mission-vision-grid">
            <div className="vision">
              <h2>Vision</h2>
              <p>
                A flourishing international Solution Focused community where people, ideas, and associations connect to co-create meaningful change through collaboration, learning, and shared practice.
              </p>
            </div>
            <div className="mission">
              <h2>Mission</h2>
              <p>
                To enhance and grow the Solution Focused (SF) movement across Europe by:
              </p>
              <ul>
                <li>Strengthening networks that connect practitioners, associations, and countries.</li>
                <li>Supporting the recognition and validation of the SF approach through research and accreditation.</li>
                <li>Encouraging learning, innovation, and dialogue that help the SF approach evolve and thrive.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Three Main Areas */}
      <section className="main-areas">
        <div className="container">
          <div className="areas-grid">
            <div className="area-card">
              <div className="area-image">
                <img src="/images/activities.jpg" alt="Activities" />
              </div>
              <div className="area-content">
                <h3>Activities</h3>
                <p>Conferences, workshops, summer camps and learning opportunities for professionals.</p>
                <a href="/activities" className="area-link">Learn More →</a>
              </div>
            </div>
            
            <div className="area-card">
              <div className="area-image">
                <img src="/images/taskgroups.jpg" alt="Task Groups" />
              </div>
              <div className="area-content">
                <h3>Task Groups</h3>
                <p>Specialized working groups focusing on different aspects of solution-focused work.</p>
                <a href="/task-groups" className="area-link">Learn More →</a>
              </div>
            </div>
            
            <div className="area-card">
              <div className="area-image">
                <img src="/images/research.jpg" alt="Research" />
              </div>
              <div className="area-content">
                <h3>Definition and Research</h3>
                <p>Research initiatives, publications and defining solution-focused approaches.</p>
                <a href="/research" className="area-link">Learn More →</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <Newsletter />
    </div>
  );
};

export default Home;
